@if (number) {
  @if (dialpad) {
    <a [href]="phoneURI">{{ humanizedPhone }}</a>
  } @else {
    @if (linkTo) {
      <a href="{{ linkTo }}" target="_blank">{{ humanizedPhone }}</a>
    }
    @if (!linkTo) {
      <span>{{ humanizedPhone }}</span>
    }
  }
  @if (allowCopyToClipboard) {
    <app-copy-to-clipboard [text]="humanizedPhone | phoneNumber" />
  }
} @else {
  {{ noValue | blankValueDash }}
}
